import React, { useEffect, useRef } from "react";
import DictionaryTable from "layout/dictionary/DictionaryTable";
import DictionaryActions from "layout/dictionary/DictionaryActions";
import DictionaryInfo from "layout/dictionary/DictionaryInfo";
import { useDispatch } from "react-redux";
import { fetchDictionaries } from "slices/dictionary/actions/dictionary";
import { hideInlineAlert } from "slices/app/appSlice";

const DictionaryContent = () => {
  const dispatch = useDispatch();
  const headerRef = useRef();

  useEffect(() => {
    dispatch(fetchDictionaries());
    return () => {
      dispatch(hideInlineAlert());
    };
  }, [dispatch]);

  return (
    <>
      <div
        ref={headerRef}
        className="dictionary__header"
        data-testid="dictionary-home"
      >
        <header>Dictionary Home</header>
        <span>
          Search Dictionaries are groups of phrases and terms that you want to
          search within documents.
        </span>
      </div>
      <DictionaryTable />
      <div className="dictionary__actions_info_container">
        <DictionaryActions />
        <DictionaryInfo />
      </div>
    </>
  );
};
export default DictionaryContent;
